import React from 'react';
import ButtonDefault from '../../components/ButtonDefault/ButtonDefault';
import { ReactComponent as NotFoundIcon } from '../../svg/notFoundIcon.svg';
import { useNavigate } from 'react-router-dom';

const NotFound = (props) => {

    const navigate = useNavigate();

    return (
        <div style={{ width: '100%', height: '95vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <div style={{ textAlign: 'center' }}>
                <NotFoundIcon style={{ width: "100%", height: "inherit" }} />
                <div style={{ marginTop: -100 }}>
                    <ButtonDefault text='Системийн эхлэл рүү буцах' onClick={() => {
                        navigate('/hrsuite/home');
                    }} />
                </div>
            </div>
        </div>
    );
}

export default NotFound;